const prefix = 'auth'
export const LOGIN_REQUEST = `${prefix}/login_request`
export const LOGIN_RESPONSE = `${prefix}/login_response`
export const LOGIN_ERROR = `${prefix}/login_error`
export const LOGOUT = `${prefix}/logout`

export function loginRequest(username, password) {
  return {
    type: LOGIN_REQUEST,
    payload: {
      username,
      password
    }
  }
}

export function loginResponse(username, roles) {
  return {
    type: LOGIN_RESPONSE,
    payload: {
      username,
      roles
    }
  }
}

export function logout() {
  return {
    type: LOGOUT,
    payload: {}
  }
}

export function loginError(reason) {
  return {
    type: LOGIN_ERROR,
    payload: { reason }
  }
}